import AssistClasses from './AssistClasses.js'
import formats from '../../api/formats'
import client from '../client'
import store from '../../store'
import dialogs from '../common/dialogs'
import vAssistCSVLoader from './AssistCSVLoader.vue'

class Step extends AssistClasses.Step {
  constructor (cxt) {
    // const ruleInns = v => !v || formats.isInns(v) || 'Введите правильные ИННы или Выберите компании из списка'
    super(
      'Сформируйте рассылку',
      (step) => step.model['postListDESCRIPTION'],
      {
        scheme: []
      },
      {
        postList: null,
        postList_CODE: null
      })
    this.context = cxt
    this.editable = true
    this.items = []
    this.fields = null
  }
  fillFields (fields) {
    // console.log('fillFields', fields)
    this.fields = fields
    var lScheme = []
    var cxt = this.context
    lScheme.push({
      fieldType: 'v-chips-field',
      label: 'Список рассылки ',
      name: 'postList_CODE',
      events: {
        'change': () => this.onPostListChange(),
        'remove': (key) => this.onPostListRemove(key)
      },
      chipSize: 10,
      items: (model, field) => {
        // console.log('onPostListChange', this.items)
        return this.items
      },
      size: {sm8: true, xs12: true},
      if: (model, field) => model['postTypeCode'] === 'FAVORITES'
    })
    lScheme.push({
      fieldType: 'v-btn',
      slot: 'Выбрать',
      events: {'click': () => this.selectCompanies('postList')},
      size: {sm4: true, xs12: true},
      shrink: false,
      if: (model, field) => model['postTypeCode'] === 'FAVORITES'
    })
    lScheme.push({
      fieldType: 'v-flex',
      slot: `Параметры для формирования рассылки можно загрузить из csv файла. Уникальное поле  и пустые поля будут заполнены из файла`,
      shrink: false,
      size: {sm8: true, xs12: true},
      if: (model, field) => model['postTypeCode'] === 'CSV'
    })
    lScheme.push({
      fieldType: 'v-chips-field',
      label: 'Рассылка ',
      name: 'postList_CODE',
      events: {
        'change': () => this.onPostListChange(),
        'remove': (key) => this.onPostListRemove(key)
      },
      chipSize: 10,
      items: (model, field) => {
        // console.log('onPostListChange', this.items)
        return this.items
      },
      size: {sm8: true, xs12: true},
      if: (model, field) => model['postTypeCode'] === 'CSV'
    })
    lScheme.push({
      fieldType: 'v-btn',
      slot: 'Загрузить',
      events: {'click': () => this.loadFromFile('postList')},
      size: {sm4: true, xs12: true},
      shrink: false,
      if: (model, field) => model['postTypeCode'] === 'CSV'
    })
    lScheme.push({
      fieldType: 'v-text-field',
      label: 'Введите инн',
      hint: 'Выберите компанию для получения списка участников ',
      name: 'postList',
      size: {sm6: true, xs6: true},
      if: (model, field) => model['postTypeCode'] === 'HOLDERS'
    })
    lScheme.push({
      fieldType: 'v-btn',
      slot: 'Выбрать',
      events: {'click': () => cxt.selectCompany('postList')},
      disabled: false,
      size: {sm4: true, xs4: true},
      shrink: false,
      if: (model, field) => model['postTypeCode'] === 'HOLDERS'
    })
    this.props.scheme = lScheme
    return this
  }
  syncPostList (inns, json) {
    let result = {}
    let values
    try {
      values = JSON.parse(json)
    } catch (e) {}
    if (values) {
      inns.forEach(inn => {
        result[inn] = values[inn]
      })
    }
    return JSON.stringify(result)
  }
  getFileListType (fileName) {
    let field = this.model && this.model[fileName] && this.fields[this.model[fileName]]
    return field && field.type || null
  }
  onPostListChange () {
    const getHint = company => {
      return `${company.name} (ИНН: ${formats.formatInn(company.inn)})`
    }
    const getError = company => null
    const cb = (companies) => {
      let set = new Set(inns)
      let items = companies.map(c => {
        set.delete(c.ref)
        return {value: c.ref, text: c.caption, hint: getHint(c), error: getError(c)}
      })
      set.forEach(inn => items.push({value: inn, text: inn, hint: 'Чтобы видеть название компании, добавьте компанию в Мои Контрагенты', error: null}))
      this.items = items.sort((a, b) => formats.compareString(a.text, b.text))
    }
    let fieldName = 'postList'
    let inns = this.model[fieldName + '_CODE'] ? this.model[fieldName + '_CODE'].split(', ') : []
    this.model[fieldName] = this.syncPostList(inns, this.model[fieldName])
    if (this.getFileListType(fieldName + 'Field') === 'company') {
      client.getCachedRefs(inns, cb)
    } else {
      this.items = inns.map(inn => {
        return {value: inn, text: inn, hint: '', error: null}
      }).sort((a, b) => formats.compareString(a.text, b.text))
    }
  }
  onPostListRemove (key) {
    let fieldName = 'postList'
    let inns = this.model[fieldName + '_CODE'] ? this.model[fieldName + '_CODE'].split(', ') : []
    inns = inns.filter(inn => inn !== key)
    this.model[fieldName + '_CODE'] = inns.join(', ')
  }
  mergePostList (fieldName, model, references) {
    let set = new Set(formats.splitRefCodes(model[fieldName + '_CODE']))
    let node = model[fieldName] ? JSON.parse(model[fieldName]) : {}
    let postListField = model['postListField'] ? model['postListField'] : fieldName
    references.forEach((r) => {
      set.add(r.ref)
      let item = {}
      item[postListField] = r.inn
      item[postListField + '_CODE'] = r.ref
      node[r.ref] = item
    })
    model[fieldName] = JSON.stringify(node)
    model[fieldName + '_CODE'] = Array.from(set).sort((a, b) => a - b).join(', ')
    // console.log('mergePostList', fieldName, model)
    return model
  }
  selectCompanies (fieldName) {
    const setReferences = (references) => {
      if (Array.isArray(references) && references.length > 0) {
        // console.log('selectCompanies', references)
        let model = this.model
        this.mergePostList(fieldName, this.model, references)
        model.setCurrentStep(this.context.currentStep)
      }
    }
    const setRefCodes = (refcodes) => {
      if (Array.isArray(refcodes) && refcodes.length > 0) {
        client.getCachedRefs(refcodes, setReferences)
      }
    }
    const getQuery = () => {}
    client.selectRef(this.context, setRefCodes, getQuery, true, false)
  }
  transformValuesToRefCode (fields, values, postListField) {
    return new Promise((resolve, reject) => {
      if (!(fields && fields.length > 1 && values && Object.keys(values).length > 1)) {
        reject()
      }
      let vf = Object.keys(Object.values(values)[0])
      let cf = new Set()
      let inns = new Set()
      fields.forEach(f => {
        if (f.type === 'company' && vf.includes(f.name)) {
          cf.add(f.name)
        }
      })
      Object.values(values).forEach(v => {
        cf.forEach(f => {
          if (v[f]) {
            inns.add(v[f])
          }
        })
      })
      client.convertInnToRefCode(inns)
      .then(map => {
        let result = {}
        Object.values(values).forEach(v => {
          cf.forEach(f => {
            v[f + '_CODE'] = map[v[f]]
          })
          if (v[postListField + '_CODE']) {
            result[v[postListField + '_CODE']] = v
          } else {
            result[v[postListField]] = v
          }
        })
        resolve(result)
      })
    })
  }
  loadFromFile (fieldName) {
    let postListField = this.model['postListField']
    this.loadForm(this.fields, this.model, postListField)
    .then(values => this.transformValuesToRefCode(this.fields, values, postListField))
    .then(values => {
      if (values && Object.keys(values).length > 0) {
        let model = this.model
        let set = Object.keys(values)
        model[fieldName] = JSON.stringify(values)
        model[fieldName + '_CODE'] = Array.from(set).sort((a, b) => a - b).join(', ')
        model.setCurrentStep(this.context.currentStep)
      }
    })
  }
  loadForm (fields, model, postListField) {
    const fullname = (f) => f ? `${f.target ? `/${f.target}/` : ''}${f.name}` : ''
    const types = {company: 'COMPANY', date: 'DATE', text: 'TEXT', textarea: 'TEXT', macro: 'MACRO'}
    return new Promise((resolve, reject) => {
      dialogs.register('v-assist-csv-loader', vAssistCSVLoader)
      let listFields = []
      let i = 0
      fields.forEach(f => {
        if (Object.keys(types).includes(f.type)) {
          let needAdd = false
          if (f.type === 'macro') {
            let div = document.createElement('div')
            div.innerHTML = model[fullname(f)]
            needAdd = div.innerText.length === 0
          }
          if (fullname(f) === postListField || !model[fullname(f)] || needAdd) {
            listFields.push({name: fullname(f), label: f.label, number: i++, type: types[f.type], key: fullname(f) === postListField})
          }
        }
      })
      console.log('loadForm', listFields)
      var fullscreen = store.getters.getIsMobile
      var comp = { template: `
        <v-assist-csv-loader
        v-on:close="$emit('close')"
        v-on:change="onChange"
        :fields="fields"
        :keyField="keyField"
        :fullscreen="fullscreen"></v-assist-csv-loader>
        `,
        data () {
          return {
            fullscreen: fullscreen,
            onChange: (data) => resolve(data),
            fields: listFields,
            keyField: postListField
          }
        }}
      dialogs.modal(comp)
    })
  }
}
export default {
  Step
}



// WEBPACK FOOTER //
// ./src/components/assist/StepPostList.js